import React from 'react';

import { TypographyWithTooltip } from '@lyearn/molecules';

import { useActionItemContext } from '../../context';
import { ActionNameProps } from '../../types';
import EditableInput from './EditableInput';

const ActionName = ({
  className,
  color = 'text-text-primary',
  numberOfLines = 2,
  variant = 'body-short-01',
  isRenameMode = false,
  disableRenameMode,
}: ActionNameProps) => {
  const {
    actionItem: { title, showParentName, parentActionItem: parent },
    disableInteractiveTooltip = false,
  } = useActionItemContext();

  if (isRenameMode) {
    return (
      <EditableInput
        className={className}
        color={color}
        disableRenameMode={disableRenameMode}
        variant={variant}
      />
    );
  }

  return (
    <TypographyWithTooltip
      className={className}
      color={color}
      disableInteractive={disableInteractiveTooltip}
      numberOfLines={numberOfLines}
      variant={variant}>
      <>
        {title}
        {showParentName && parent?.title ? (
          <span className="text-text-placeholder">{` › ${parent?.title}`}</span>
        ) : null}
      </>
    </TypographyWithTooltip>
  );
};

export default React.memo(ActionName);
